import React from "react";
import { crypt, decrypt } from "../encryption/encryption";
import { browserName } from "react-device-detect";
import { isB2C, isNovium } from "../../libs/env";
export function AudioPlayer({ data, studentid, studentAssessmentId, type }) {
  let audiomt = "my-3"
  if (isB2C.some(domain => window.location.origin.includes(domain))  || window.location.origin.includes(isNovium) )
  {
    audiomt = "mt-3"
  }
  let audioSize = `audio-size ${audiomt}`;
  if( browserName.toLowerCase().includes("safari"))
  {
    audioSize = `saf-audio-size ${audiomt}`;
  }
  let get_data_from_local_storage = JSON.parse(
    localStorage.getItem(
      `${data.type}${data.id}${studentid}${studentAssessmentId}data`
    )
  );
  let stored_time = 0;
  let stored_counter = 0;
  if (get_data_from_local_storage) {
    stored_time = parseInt(decrypt("salt", get_data_from_local_storage.time));
    stored_counter = parseInt(
      decrypt("salt", get_data_from_local_storage.count)
    );
  }
  let currentTime = stored_time;
  let previousTime = stored_time;
  let total_duration = 0;
  let counter = stored_counter;
  let clicked_on_play = false;

  const saveDataInLocalStorage = () => {
    let save_data = {
      time: crypt("salt", `${currentTime}`),
      count: crypt("salt", `${counter}`),
    };
    localStorage.setItem(
      `${data.type}${data.id}${studentid}${studentAssessmentId}data`,
      JSON.stringify(save_data)
    );
  };

  const timeUpdate = (e) => {
    previousTime = currentTime;
    currentTime = e.target.currentTime;
    saveDataInLocalStorage();
  };

  const onPlay = (e) => {
    if (get_data_from_local_storage) {
      e.target.currentTime = currentTime;
      clicked_on_play = true;
    }

    if (total_duration === 0) {
      total_duration = e.target.duration;
    }
  };

  const onPause = (e) => {
    if (
      data.disable_rewind_pause_skip &&
      e.target.currentTime !== total_duration
    ) {
      e.target.play();
    }
    playAudioLimitedTimes();
  };

  const playAudioLimitedTimes = () => {
    if (currentTime === total_duration) {
      if (counter === data.number_of_times_audio_track_play) {
        return;
      }
      counter += 1;
      if (counter !== data.number_of_times_audio_track_play) {
        currentTime = 0;
        previousTime = 0;
      }
    }
  };

  const onStartSeeking = (e) => {
    if (data.disable_rewind_pause_skip) {
      if (clicked_on_play && get_data_from_local_storage) {
        get_data_from_local_storage = null;
        clicked_on_play = false;
      } else {
        if (previousTime < e.target.currentTime) {
          e.target.currentTime = previousTime;
        } else if (previousTime > e.target.currentTime) {
          e.target.currentTime = previousTime;
        }
      }
    }
  };

  return (
    <audio
      className={`${audioSize}`}
      controls
      controlsList="noplaybackrate nodownload"
      onPlay={onPlay}
      onPause={onPause}
      onTimeUpdate={timeUpdate}
      onSeeking={onStartSeeking}
    >
      <source src={`${data.audio}`} type={type} />
    </audio>
  );
}
